import { CaseGranulometry } from '../../CaseGranulometry';
import { CarpentryOccultationsTypeName } from '../../../../specification/cases/CarpentryOccultationsType';

export const hasCaseCarpentryDayAndNightTimeOccultations = (
  caseGranulometry: CaseGranulometry
): boolean =>
  caseGranulometry.carpentryDayTimeOccultationsType !== CarpentryOccultationsTypeName.None &&
  caseGranulometry.carpentryNightTimeOccultationsType !== CarpentryOccultationsTypeName.None;
